import React, { useMemo } from 'react';
import { Flex } from '@instructure/ui';
import { getStore, usePlayerStore } from '../../../../stores/StoreContext';
import Annotations from './Annotations';
import Phases from './Phases';
//import Connection from './Connection';

const AnnotationMarkersRenderer = () => {
  const PlayerStore = getStore('playerStore');
  const displayMarkers = usePlayerStore((state) => state.displayMarkers);
  const markersDisplayProperties = usePlayerStore((state) => state.markersDisplayProperties);

  // Memoize markers rendering. It will re-run when displayMarkers or PlayerStore.markers changes.
  const markers = useMemo(() => {
    return PlayerStore.markers
      .filter((marker) => displayMarkers.includes(marker.id))
      .map((marker) => (
        <Flex.Item
          position="relative"
          id={`marker_${marker.id}`}
          key={`marker_${marker.id}`} // Using marker.id as a stable key
          as="div"
          width="100%"
          height={`${markersDisplayProperties[marker.id].height}px`}
          shouldGrow
          withVisualDebug={false}
        >
          {marker.id === 'phases' && <Phases />}
          {marker.id === 'flags' && <Annotations type={marker} />}
        </Flex.Item>
      ));
  }, [displayMarkers, PlayerStore.markers, markersDisplayProperties]);

  return (
    <Flex
      as="div"
      withVisualDebug={false}
      direction="column"
      alignItems="center"
    >
      {markers}
    </Flex>
  );
};

export default React.memo(AnnotationMarkersRenderer);
